export class BrowserBack {
  trigger: HTMLAnchorElement

  constructor(goBackTrigger) {
    this.trigger = goBackTrigger
    this.replaceHref()
  }

  replaceHref() {
    if (document.referrer.search(this.trigger.href) > -1) {
      this.trigger.href = document.referrer
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll<HTMLElement>('[data-history-back]').forEach((goBackTrigger) => {
    new BrowserBack(goBackTrigger)
  })
});
